import { countryMap } from '@/shared/dictionaries/countries';
import { dates } from '@/shared/utils/dates';
import { capitalizeFirstLetter } from '@/shared/utils/misc';

import { PrivateDocFieldType } from '../types';

export const getSectionDataValue = (fieldDef: PrivateDocFieldType) => {
  const { formKey, value } = fieldDef;

  if (formKey === 'country') {
    if (typeof value !== 'string') return '';
    return countryMap.get(value)?.label ?? '';
  }

  if (value === undefined) return '-';

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? '-' : dates.formatLongDate(value);
  }

  if (typeof value === 'string' && dates.isValidIsoFormat(value)) {
    return dates.formatLongDate(new Date(value));
  }

  return capitalizeFirstLetter(Array.isArray(value) ? value[0] : value);
};
